import { useCallback, useEffect, useState } from 'react'

interface UseMediaDevicesOptions {
  deviceType?: 'audioinput' | 'videoinput' | 'audiooutput'
}

export function useMediaDevices({ deviceType }: UseMediaDevicesOptions): MediaDeviceInfo[] {
  const [mediaDevices, setMediaDevices] = useState<MediaDeviceInfo[]>([])

  const getMediaDevices = useCallback(({ deviceType }: UseMediaDevicesOptions) => {
    navigator.mediaDevices
      ?.enumerateDevices()
      .then((devices) => {
        const filteredDevices = devices.filter(
          (device) => (!deviceType || device.kind === deviceType) && !!device.deviceId
        )
        setMediaDevices(filteredDevices)
      })
      .catch(() => {
        setMediaDevices([])
      })
  }, [])

  useEffect(() => {
    getMediaDevices({ deviceType })
    const handleDeviceChange = () => getMediaDevices({ deviceType })
    navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange)

    return () => navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange)
  }, [getMediaDevices, deviceType])

  return mediaDevices
}
